import defineComponent from 'flight';
import WithAjax from 'static/script/app/data/with-ajax';

function ServerTimePing() {
    this.defaultAttrs({
        auctionEnd: '[data-auction-ends]',
        timeLeftThreshold: 2 * 60 * 60 * 1000, //2 hours
        featureSwitches: null,
        retries: 2,
        delayLimit: 500
    });

    this._queryServerTime = function(retryCount) {
        let requestStart = Date.now();

        let success = function(data) {
            let delay = this._getNetworkDelay(requestStart);

            if (delay < this.attr.delayLimit) {
                this._broadcastServerTime(Date.parse(data.currentTime), delay);
                this._logPingDelay('countdown.ping.success', delay);
            } else if (retryCount < this.attr.retries) {
                this._queryServerTime(retryCount + 1);
                this._logPingDelay('countdown.ping.retry.' + retryCount, delay);
            } else {
                this._logPingDelay('countdown.ping.fail', delay);
            }
        };

        this._get({
            url: '/ping',
            success: success.bind(this)
        });
    };

    this._getNetworkDelay = function (requestStart) {
        return Date.now() - requestStart;
    };

    this._logPingDelay = function(name, delay) {
        let payload = {
            eventName: 'timing',
            name: name,
            ms: delay
        };
        this.trigger(document, 'data:scribe', payload);
    };

    this._broadcastServerTime = function(serverTime, delay) {
        this.trigger(document, 'data:server-time', {
            clientTime: Date.now(),
            serverTime: serverTime,
            networkDelay: delay
        });
    };

    this._init = function() {
        let auctionEndTime = this.select('auctionEnd').data('auction-ends');
        if(!auctionEndTime){
            return;
        }
        let auctionTimeLeft = auctionEndTime - Date.now();

        if (auctionTimeLeft > 0 && auctionTimeLeft < this.attr.timeLeftThreshold) {
            this._queryServerTime(0);
        }
    };

    this.after('initialize', function() {
        if (this.attr.featureSwitches && this.attr.featureSwitches['vip-countdown-ping']) {
            this._init();
        }
    });

}

module.exports = defineComponent.component(ServerTimePing, WithAjax);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/data/server-time-from-ping.js